import queryDuck from '@/ducks/queryDuck.js';
import srpActiveInteractionDuck from '@/ducks/srp/srpActiveInteractionDuck.js';

export const categoryOptions = [
    {
        label: 'All Results',
        icon: 'allResults',
        filterName: 'allResults',
        value: 'allResults',
    },
    {
        label: 'Best Deals',
        icon: 'goodDeals',
        filterName: 'dealType',
        value: {
            dealType: ['goodprice', 'greatprice'],
        },
    },
    {
        label: 'Buy Online',
        icon: 'buyOnline',
        filterName: 'homeServices',
        value: {
            homeServices: ['BUY_ONLINE'],
        },
    },
    {
        label: 'For Sale By Owner',
        icon: 'ownerSale',
        filterName: 'sellerType',
        value: {
            sellerType: ['p'],
        },
    },
    {
        label: 'Certified Used',
        icon: 'certifiedUsed',
        filterName: 'listingType',
        value: {
            listingType: ['CERTIFIED', '3P_CERT'],
        },
    },
];

export function removeCategory({ activeCategory, filterValue, dispatch }) {
    if (activeCategory !== 'All Results') {
        const activeCategoryObject = categoryOptions.find((option) => option.label === activeCategory);
        const activeCategoryValues = !!activeCategoryObject && Object.values(activeCategoryObject?.value)[0];

        if (activeCategoryValues.includes(filterValue)) {
            dispatch(srpActiveInteractionDuck.creators.setKeys({
                activeCategory: 'All Results',
            }));
            dispatch(queryDuck.creators.setKeys({
                categorySearch: 'allResults',
            }));
        }
    }
}

export const getCategoryFromQueryParams = ({ filtersValues, query }) => {
    const { categorySearch = '' } = query;
    const category = categoryOptions.find((option) => option.filterName === categorySearch);

    const filtersMatchQueryParam = Object.keys(filtersValues).includes(category?.filterName);

    if (category && filtersMatchQueryParam) {
        return category.label;
    }

    return 'All Results';
};

export function getNonCategoryFiltersValues({ filtersValues = {}, selectedCategoryValue = {} }) {
    // Get array of all Category values combined
    const combinedCategoryValuesFlat = categoryOptions.flatMap((option) => (
        typeof option.value === 'object' ? Object.values(option.value).flat() : [option.value]));

    if (Object.keys(selectedCategoryValue)[0] === 'listingType') {
        combinedCategoryValuesFlat.push('NEW', 'USED');
    }

    // Create a new object of filtersValues but without the values that are in combinedCategoryValuesFlat
    const retainedFilters = {};
    Object.entries(filtersValues).forEach(([key, value]) => {
        const filteredValues = Array.isArray(value) ? value.filter((item) => !combinedCategoryValuesFlat.includes(item)) : value;
        if (filteredValues.length > 0) {
            Object.assign(retainedFilters, { [key]: filteredValues });
        }
    });

    // Update retained filters values to not have pipes (ex: makeCode & trimCode)
    return !!retainedFilters && Object.fromEntries(
        Object.entries(retainedFilters).map(([key, value]) => [key.split('|')[0], value])
    );
}

export default {
    categoryOptions,
    getCategoryFromQueryParams,
    getNonCategoryFiltersValues,
    removeCategory,
};
